module.exports = __webpack_public_path__ + "/images/ico-color-list-heart.f018f2f.svg";